<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
          <el-form-item label="小区分组" prop="communityGroup">
            
            <el-select style="width: 100%" v-model="form.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="小区名称"
              prop="communityId"
              :rules="[{ required: true, message: '请选择小区', trigger: 'blur' }]"
            >
              <el-select
                v-model="form.communityId"
                multiple
                filterable
                collapse-tags
                @change="selectAll"
                style="margin-left: 20px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="扎帐年月">
              <el-date-picker
                v-model="form.monthNo"
                type="month"
                :clearable="false"
                placeholder="选择扎帐年月"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WebReport from '@/components/web-report';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import urlSettings from '@/config/url-settings.js';
import { getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      communityGroupList:[],
      url: '',
      form: {
        communityGroup:'',
        communityId: [],
        monthNo: '',
      },
      allPropertyList: [],
      oldOptions: [],
      params: {
        reportlet: urlSettings.VUE_APP_ENVIRONMENT + '/fin_debt.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  methods: {
        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
          this.form.communityId = [];
            this.initPropertyList((data)=>{
              // this.query.propertyId = data[0].id;
              this.form = _.cloneDeep(this_.form);
              // this.onLoad();
            });
        },
    selectAll(val) {
      let allValues = []; //保留所有值
      let value = []; //保留所选的值

      for (let item of this.allPropertyList) {
        allValues.push(item.id);
      }
      // 用来储存上一次的值，可以进行对比
      const oldVal = this.oldOptions;

      // 若是全部选择
      if (val.indexOf('0000') != -1) {
        value = allValues;
      }

      // 取消全部选中  上次有 当前没有 表示取消全选
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') == -1) {
        value = [];
      }

      // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      // 新老数据都有全部选中
      if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') != -1) {
        if (val.length < allValues.length) {
          const index = val.indexOf('0000');
          val.splice(index, 1); // 排除全选选项
          value = val;
        } else {
          value = val;
        }
      }

      //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      if (oldVal.indexOf('0000') == -1 && val.indexOf('0000') == -1) {
        if (val.length === allValues.length - 1) {
          value = ['0000'].concat(val);
        } else {
          value = val;
        }
      }

      //储存当前最后的结果 作为下次的老数据
      this.oldOptions = value;
      this.form.communityId = value;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.communityId = `(${this.form.communityId.join(',')})`;
          this.params.monthNo = this.dayjs(this.form.monthNo).format('YYYYMM');

          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    initPropertyList(cb) {
      var that = this;
      getOptionNode({communityGroup:that.form.communityGroup}).then((data) => {
        this.allPropertyList = data.data;
        let obj = {};
        obj.title = '全部';
        obj.id = '0000';
        this.allPropertyList.unshift(obj);
        this.form.communityId.push(this.allPropertyList[1].id);
        this.params.communityId = `(${this.allPropertyList[1].id})`;
        this.form.monthNo = new Date();
        this.params.monthNo = this.dayjs(this.form.monthNo).format('YYYYMM');
        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        cb(data.data);
        // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2Ffin_debt.cpt';
        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    let this_ = this;
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.form.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              // this.form.communityId = data[0].id;
              this.form = _.cloneDeep(this_.form);
              // this.onLoad();
          });
      });
    // this.params.communityId = `(0)`;
    // this.form.monthNo = new Date();
    // this.params.monthNo = this.dayjs(this.form.monthNo).format('YYYYMM');
    // var reportUrl = urlSettings.BASE_REPORT_URL;
    // this.url = reportUrl.split('?')[0];
    // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2Ffin_debt.cpt';
  },
};
</script>

<style></style>
